import PlatformApi from './_platformApi';
import httpClient from '@/apis/base/httpclient';

class DbOptionApi extends PlatformApi {
  constructor() {
    super();
  }
  controllerName = 'DbOptions';

  /**
   * Lấy danh sách các option của tenant
   * @returns {Promise<Array>} Danh sách các option
   */
  getDbOptions() {
    const request = {
      url: `${this.getAPIUrl()}/get-by-tenant`,
    };
    return httpClient.getAsync(request);
  }
  /**
   * cập nhật option của tenant
   * @param {*} payload
   * @returns
   */
  updateDbOption(payload) {
    const request = {
      url: `${this.getAPIUrl()}/dboptions`,
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /**
   * cập nhật option theo user và tenant
   * @param {*} payload
   * @returns
   * nttung10-18/6/2026
   */
  UpdateDbOptionByUserAndTenantId(payload) {
    const request = {
      url: `${this.getAPIUrl()}/dboptions-by-user-tenant`,
      data: payload,
    };
    return httpClient.postAsync(request);
  }
}

export default new DbOptionApi();
